var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isActive)?_c('div',{attrs:{"id":_vm.tab,"aria-labelledby":_vm.buttonId,"role":"tabpanel","tabindex":"0"}},[_vm._t("default")],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }